<template>
  <div class="content-tree sys-center-zuzhijigou">
    <lr-tree
      :data="treeData"
      @setTreeWidth="setTreeWidth"
      :width="width"
      :loading="treeLoading"
      :ref="treeBindRef"
      :bindRef="treeBindRef"
      nodeKey="ID"
      :title="treeTitle"
      @nodeClick="nodeClick"
      :defaultProps="defaultProps"
    ></lr-tree>
  </div>
</template>

<script>
export default {
  name: "AuthDeptTree",
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  data() {
    return {
      treeLoading: false,
      treeBindRef: "tree",
      treeTitle: "组织机构",
      defaultProps: {
        children: "children",
        label: "Name",
      },
    };
  },
  computed: {
    treeData() {
      console.log(this.$store.state.permission, "this.$store.state.permission")
      return this.$store.state.permission.authOrgData ?this.$store.state.permission.authOrgData: [];
    },
  },
  watch:{
    treeData: {
      handler: function (n, o) {
        this.$nextTick(()=>{
          if(this.treeData[0].length==0){
            return false;
          }
          this.$emit("nodeClick", this.treeData[0]);
          this.$refs[this.treeBindRef].setCurrentKey(this.treeData[0].ID)
        })
      },
      immediate: true,
    },
   
  },
  methods: {
    setTreeWidth(width) {
      this.$emit("setTreeWidth", width);
    },
    iconClass(row) {
      return row.data.Type === 2 || row.data.Type === 3
        ? "icon-biaoqian"
        : row.data.expanded
        ? "icon-dakai1"
        : "icon-wenjiandai";
    },

    nodeClick(obj) {
      this.$emit("nodeClick", obj.obj);
    },
  },
};
</script>
<style scoped  lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/LrOrganization/AuthDeptTree.vue